package com.ilussobsa.views

import com.ilussobsa.*
import com.ilussobsa.Strings
import com.ilussobsa.sdk.*
import com.ilussobsa.utils.settings2
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.locale.RenderSize
import com.lightningkite.kiteui.locale.renderToString
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.UrlLikePath
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.children
import com.lightningkite.kiteui.views.l2.icon
import com.lightningkite.lightningdb.*
import com.lightningkite.now
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import kotlinx.coroutines.launch
import kotlinx.datetime.Instant

@Routable("/notifications")
class NotificationsScreen : Page {
    override fun ViewWriter.render() = frame {
        val lastCheck = Signal<Instant>(Instant.DISTANT_PAST)
        launch {
            lastCheck set (currentUserSession().me.awaitNotNull().notificationsLastCheckedAt)
            currentUserSession().user[currentUserSession().userId].modify(modification {
                it.notificationsLastCheckedAt assign now()
            })
        }
        card - gravity(Align.Center, Align.Stretch) - sizedBox(SizeConstraints(width = 95.rem)) - col {
            row {
                centered - icon(Icon.notification, "notifications")
                centered - h2(Strings.notifications)
            }
            separator()
            expanding - frame {
                val a = remember {
                    currentUserSession().notification.watch(
                        Query(
                            condition = condition<Notification> { it.receiver eqNn currentUser()?._id },
                            orderBy = sort<Notification> { it.at.descending() }
                        ))
                }
                val data = remember {
                    a()()
                }
                recyclerView {
                    children(
                        items = data,
                        id = { it._id }
                    ) {
                        important - link {
                            ::opacity {
                                if (it().at > lastCheck()) 1.0 else 0.5
                            }
                            row {
                                expanding - col {
                                    h3 { ::content { it().title } }
                                    text { ::content { it().content ?: "" } }
                                }
                                col {
                                    atEnd - text { ::content { it().at.renderToString(RenderSize.Abbreviation) } }
                                }
                            }
                            ::to {
                                try {
                                    it().link?.let {
                                        {
                                            AutoRoutes.parse(UrlLikePath.fromUrlString(it)) ?: NotificationsScreen()
                                        }
                                    }
                                } catch (e: Exception) {
                                    null
                                } ?: { NotificationsScreen() }
                            }
                        }
                    }
                }
                frame {
                    exists = false
                    ::shown { data().isEmpty() }
                    nothingSelected(Strings.youHaveNoNotificationsYet)
                }
            }
        }
    }
}


@Routable("notifications/settings")
class NotificationSettingsScreen : Page {
    override fun ViewWriter.render() = frame {
        val isSeller = MutableRemember {
            currentUserSessionNullable()?.me()?.role?.let { it >= UserRole.Manager } == true
        }
        frame {
            card - gravity(Align.Center, Align.Stretch) - sizedBox(SizeConstraints(width = 95.rem)) - scrolls - col {
                row {
                    centered - icon(Icon.settings2, "notification settings")
                    centered - h2(Strings.notificationSettings)
                }
                separator()
                NotificationTopic.entries.groupBy { it.section }.forEach { (section, types) ->
                    col {
                        onlyWhen {
                            types.any { t ->
                                when (t.forUserType) {
                                    NotificationUserType.SellerOnly -> isSeller()
                                    NotificationUserType.BuyerOnly -> !isSeller()
                                    else -> true
                                }
                            }
                        } - h2(section)
                        types.forEach { type ->
                            onlyWhen {
                                when (type.forUserType) {
                                    NotificationUserType.SellerOnly -> isSeller()
                                    NotificationUserType.BuyerOnly -> !isSeller()
                                    else -> true
                                }
                            } - row {
                                expanding - compact - col {
                                    h6(type.title)
                                    subtext(type.description)
                                }
                                important - toggleButton {
                                    col {
                                        spacing = 0.1.rem
                                        centered - icon {
                                            source = Icon.notification
                                            description = Strings.inApp
                                        }
                                        centered - subtext(Strings.inApp)
                                    }
                                    checked bind remember {
                                        currentUserSession().me.awaitNotNull().notify(type).push
                                    }.withWrite { value ->
                                        currentUserSession().user[currentUserSession().userId].modify(modification {
                                            it.notify(type).push assign value
                                        })
                                    }
//                                    checked bind currentUser.prop { it.notify(type).push }
                                }
                                important - toggleButton {
                                    col {
                                        spacing = 0.1.rem
                                        centered - icon {
                                            source = Icon.email
                                            description = Strings.email2
                                        }
                                        centered - subtext(Strings.email2)
                                    }
                                    checked bind remember {
                                        currentUserSession().me.awaitNotNull().notify(type).email
                                    }.withWrite { value ->
                                        currentUserSession().user[currentUserSession().userId].modify(modification {
                                            it.notify(type).email assign value
                                        })
                                    }
//                                    checked bind currentUser.prop { it.notify(type).email }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}